import React from "react";
import Sidebar from "../components/Sidebar";
import CalendarioTurnero from "./CalendarioTurnero";
import "./TurneroPage.css";

export default function TurneroPage() {
  return (
    <div className="turnero-layout">
      <Sidebar />
      <main className="turnero-main">
        <CalendarioTurnero />
      </main>
    </div>
  );
}
